import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { computedMetricsSelector } from './computed-metrics.selectors';
import { getLayoutValueSelector } from '../../layout/selectors/layout.selectors';

export const metricSelector = ({ metrics }: DefaultRootState) => metrics;

export const getMetricsSelector = createSelector(
  metricSelector,
  computedMetricsSelector,
  getLayoutValueSelector('withComputedMetrics'),
  (metric, computedMetrics, withComputedMetrics) =>
    withComputedMetrics ? computedMetrics : metric,
);
